import React, {useEffect} from 'react';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {TransfersContextProvider} from "../../components/TransfersContext";
import PageHeader from '../../../../common/components/ui/PageHeader';
import ButtonDownload from '../../components/ButtonDownload';
import UnpaidReceiptsStatsPanel from "../../components/UnpaidReceiptsStatsPanel";
import UnpaidReceiptsGrid from "../../components/UnpaidReceiptsGrid";
import Notes from "../../components/Notes";
import TransfersStatsPanel from '../../components/TransfersStatsPanel';
import TransfersGrid from '../../components/TransfersGrid';
import FooterDivider from "../../../../common/components/ui/FooterDivider";
import FooterLogo from "../../../../common/components/ui/FooterLogo";
import styles from './Transfers.module.scss';

const Transfers = () => {
  const {setPageTitle} = useGlobalContext();
  const {setPopupPanelContent, closePopupPanel} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'transfers-page-header'}
        defaultMessage={'Transfers'}
      />
    ));

    return () => {
      closePopupPanel();
      setPopupPanelContent(null);
    };
  }, []);

  return (
    <TransfersContextProvider>
      <UnpaidReceiptsStatsPanel/>
      <UnpaidReceiptsGrid/>
      <Notes/>
      <div className={styles.buttonDownloadContainer}>
        <TransfersStatsPanel/>
        <ButtonDownload/>
      </div>
      <TransfersGrid/>
      <FooterDivider/>
      <FooterLogo/>
    </TransfersContextProvider>
  );
};

export default Transfers;
